// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attendance-selectors{
  margin-bottom: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.no-debts{
  margin-top: 70px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.no-debts-title{
  margin-right: 30px;
  font-size: 40px;
  font-weight: 600;
}

.unpaid-debts-title{
  margin-bottom: 20px;
  color: #434C63;
}


@media screen  and (max-width: 520px) {
  .no-debts{
    margin-top: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Debts/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".attendance-selectors{\n  margin-bottom: 40px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.no-debts{\n  margin-top: 70px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.no-debts-title{\n  margin-right: 30px;\n  font-size: 40px;\n  font-weight: 600;\n}\n\n.unpaid-debts-title{\n  margin-bottom: 20px;\n  color: #434C63;\n}\n\n\n@media screen  and (max-width: 520px) {\n  .no-debts{\n    margin-top: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
